// extracted by mini-css-extract-plugin
export default {"size-close-icon":"CancelButton_size-close-icon__ycevB"};